import {emptyValidator, formValidator} from "../../validators";


const saveTemplateValidationStatus = {
    intTemplateName: {
        validators: [emptyValidator()],
        name: "Template Name is required",
    },
    intCategory: {
        validators: [emptyValidator()],
        name: "Category is required",
    },
   
}

export const chargeTemplateCreationValidation = (templateDetails) => {
    return formValidator(templateDetails, saveTemplateValidationStatus);
}